module.exports = __webpack_public_path__ + "img/108.b7a7ed88.jpg";